/* eslint-disable */
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import getDisplayDate from '../../../../utils/displayDate';
import CountdownTimer from '../../SharedComponents/CountdownTimer/CountdownTimer';
import { OPEN_SOON_SELECT_NEW_MEMBER_MID_WINDOW } from '../../../../utils/customizePageStates';
import * as classNames from './Pre.module.css';

function PreCopy({ customizePage, openDate, isMobile, nmcShowSelectMidWindowCopy }) {
  if (nmcShowSelectMidWindowCopy && customizePage === OPEN_SOON_SELECT_NEW_MEMBER_MID_WINDOW) {
    return (
      <div className={classNames.annualMidWindow}>
        <p
          className={cx(classNames.amwEmphasize, {
            [classNames.mobile]: isMobile,
          })}
        >
          You&apos;ll Customize During the Seasonal Members Window
        </p>
        <p
          className={cx(classNames.amwSummary, {
            [classNames.mobile]: isMobile,
          })}
        >
          Because you joined after the Annual window, your customizations will be part of the
          Seasonal window. We saved your choices from onboarding and you can edit them while the
          Seasonal window is open.
        </p>
        <p
          className={cx(classNames.amwDisclaimer, {
            [classNames.mobile]: isMobile,
          })}
        >
          Note: Your box will ship with the Seasonal window
          <a
            className={classNames.scheduleLink}
            href="https://support.fabfitfun.com/en/articles/4-billing-shipping-schedule"
          >
            Billing / Shipping Schedule
          </a>
        </p>
      </div>
    );
  }
  return (
    <Fragment>
      <p className={classNames.psEmphasize}>
        {`Customization Will Open for You on ${getDisplayDate(openDate)}`}
      </p>
      <p className={classNames.psSummary}>
        This is where you’ll see your box customizations after you’ve selected them.
      </p>
    </Fragment>
  );
}

PreCopy.propTypes = {
  customizePage: PropTypes.string.isRequired,
  openDate: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  nmcShowSelectMidWindowCopy: PropTypes.bool.isRequired,
};

function Pre({ openDate, isMobile, timerRefresh, customizePage, flags }) {
  const { nmcShowSelectMidWindowCopy } = flags;
  return (
    <div
      className={cx(classNames.preState, {
        [classNames.mobile]: isMobile,
      })}
    >
      <CountdownTimer openDate={openDate} timerRefresh={timerRefresh} />
      <PreCopy
        customizePage={customizePage}
        openDate={openDate}
        nmcShowSelectMidWindowCopy={nmcShowSelectMidWindowCopy}
      />
    </div>
  );
}

Pre.propTypes = {
  openDate: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  timerRefresh: PropTypes.func.isRequired,
  customizePage: PropTypes.string.isRequired,
  flags: PropTypes.shape({
    nmcShowSelectMidWindowCopy: PropTypes.bool.isRequired,
  }).isRequired,
};

export default withLDConsumer()(Pre);
